import { ContentBlockerWrapper } from "@aleksundshantu/aunds-cookie-plugin-react";
import { isEmpty } from "lodash";
import { ReactNode } from "react";

interface ExtendedConsentManagementProps {
  children: ReactNode;
  type_consent_management: string;
  className?: string;
}

export const ExtendedConsentManagement = ({
  type_consent_management,
  children,
  className,
}: ExtendedConsentManagementProps) => {
  const hasConsent = isEmpty(type_consent_management);

  return hasConsent ? (
    <>{children}</>
  ) : (
    <ContentBlockerWrapper
      wpApiUrl={process.env.WP_API_URL!}
      platformName={type_consent_management || "unknown"}
      extraClassName={
        className
          ? { wrapper: className + ` content-placeholder` }
          : { wrapper: ` content-placeholder` }
      }
    >
      {children}
    </ContentBlockerWrapper>
  );
};
